/**
 * Provides the base abstraction for native Intl.NumberFormat function
 */
const numberFormat = (locale?: string | string[]) => (config?: Intl.NumberFormatOptions) => (value: number) =>
  Intl.NumberFormat(locale, config).format(value);

export default numberFormat;

/**
 * The base `numberFormat` function extended with locale
 */
export const formatWithLocale = numberFormat('en-US');

export const formatNumber = formatWithLocale();

export const formatCurrency = ({ currency = 'EUR', ...options }) =>
  formatWithLocale({
    ...options,
    currency,
    style: 'currency',
  });
